<template>
  <div
    ref="popupParent"
    :class="['buttons-bottom-header__item', 'orders-header', '_with-popup', {_disabled: !ordersCount}]"
    @mouseover="showPopup"
    @mouseout="hidePopup"
  >
    <a
      href="/orders/" class="buttons-bottom-header__link"
      data-list-type="jsOrderList"
    >
      <div class="buttons-bottom-header__icon">
        <svg
          width="22" height="22"
          viewBox="0 0 22 22" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5 11H16M22.5 11H21M21 11V13.0858C21 13.351 20.8946 13.6054 20.7071 13.7929L16.2929 18.2071C16.1054 18.3946 16 18.649 16 18.9142V21M21 11H16M16 21H21M16 21H14.5M22.5 21H21M21 21V18.9142C21 18.649 20.8946 18.3946 20.7071 18.2071L16.2929 13.7929C16.1054 13.6054 16 13.351 16 13.0858V11" stroke="#474747"
            stroke-width="1.75" stroke-linecap="round"
          />
          <path
            d="M12 19H3.70711C3.25435 19 2.82014 18.8201 2.5 18.5V18.5C2.17986 18.1799 2 17.7456 2 17.2929V17C2 15.8954 2.89543 15 4 15V15M12 15H4M4 15V4C4 3.44772 4.44772 3 5 3H18C18.5523 3 19 3.44772 19 4V8" stroke="#474747"
            stroke-width="1.75" stroke-linecap="round"
          />
          <path
            d="M11 7H16" stroke="#474747"
            stroke-width="1.75" stroke-linecap="round"
          />
          <circle
            cx="8" cy="7"
            r="1" fill="#474747"
          />
          <circle
            cx="8" cy="11"
            r="1" fill="#474747"
          />
        </svg>
        <div class="items-count" style="display: none">1</div>
        <div v-if="ordersCount" class="buttons-bottom-header__icon-count items-count__show">
          {{ ordersCount }}
        </div>
      </div>
      <span>Статус заказа</span>
    </a>
    <div class="buttons-bottom-header__item-popup">
      <orderBlock
        v-for="(item, index) of orders"
        :key="`header-orders-${index}`"
        class="order-item"
        :is-authorized="true"
        :order-title="item.number"
        :order-date="item.dateCreated"
        :order-status="item.status"
      />
    </div>
  </div>
</template>

<script>
import orderBlock from '../../components/orderBlock.vue';
import api from './services/api';

export default {
  name: 'order-popup',

  components: {
    orderBlock,
  },

  data() {
    return {
      orders: [],
    };
  },

  computed: {
    ordersCount() {
      return this.orders.length;
    },
  },

  async mounted() {
    await this.getOrders(true);

    window.addEventListener('phpSessIdUpdate', async () => {
      await this.getOrders();
    });
    setInterval(async () => {
      await this.getOrders();
    }, 1000 * 60 * 10);

    window.addEventListener('beforeunload', () => {
      window.localStorage.removeItem('orderPopupItems');
    });
  },

  methods: {
    showPopup() {
      this.$refs.popupParent.classList.add('_with-popup--active');
    },
    hidePopup() {
      this.$refs.popupParent.classList.remove('_with-popup--active');
    },
    async getOrders(firstLoad = false) {
      const dataFromStorage = localStorage.getItem('orderPopupItems');
      if (firstLoad && dataFromStorage) {
        this.orders = JSON.parse(dataFromStorage);

        return;
      }
      const response = await api.getOrders();
      const { data } = response;
      if (!data?.error) {
        const filteredData = data.filter((order) => order.status !== 'Выполнен' || order.status !== 'Отменён');
        localStorage.setItem('orderPopupItems', JSON.stringify(filteredData));
        this.orders = filteredData;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
._disabled {
  display: none;
}
.buttons-bottom-header__item-popup {
  max-height: 452px;
  padding: 16px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: #F1F1F1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #333332;
    border-radius: 4px;
  }
}
.order-item + .order-item {
  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    margin: 12px 0 12px 0;
    background-color: #C5C5C5;
  }
}
</style>
